import { helper } from '@ember/component/helper';
import { isBetween } from 'my-phorest/utils/local-date-helpers';

export default helper(function isBetweenDates(
  [thisDate, startDate, endDate] /*, hash*/
) {
  return isBetween(thisDate, startDate, endDate);
});
